import React, { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Input from "../../../../components/form/Input";
import Select from "../../../../components/form/Select";
import { useFormikContext } from "formik";
import DimensionsModal from "../../../../components/TablePro/fields/DimensionsField";
import { formatLocationDimensions } from "../../../../utils/dimensions";
import {
  CreatingModeField,
  LocationNameFields,
  LocationPreview,
} from "./LocationNamingFields";

const mobileLocationTypes = [
  ["vault", "Vault"],
  ["pallet", "Pallet"],
  ["virtual_pallet", "Virtual Pallet"],
  ["trailer", "Trailer"],
  ["portable_container", "Portable Container"],
];

export default function MobileLocationCreation() {
  const { values, setFieldValue } = useFormikContext();
  const [openDimensions, setOpenDimensions] = useState(false);
  const currentDimensions = values?.dimensions || [];
  const hasCreatingMode = values.creatingMode === "single" || values.creatingMode === "multiple";

  const handleDimensionsSave = dimensions => {
    setFieldValue("dimensions", dimensions);
  };

  return (
    <Box>
      <Box display="flex" flexDirection="column" gap={2}>
        <CreatingModeField />
        {hasCreatingMode && (
          <>
            <Select
              size="medium"
              name="locationType"
              label="Mobile Location Type"
              options={mobileLocationTypes}
              showNAButton={false}
            />
            <LocationNameFields />
            <Input
              size="medium"
              name="sqFtOfSlot"
              label="Location Square Feet"
              type="number"
              showNAButton={false}
            />
            <TextField
              fullWidth
              size="medium"
              variant="outlined"
              label='Dimensions W" x D" x H"'
              value={formatLocationDimensions(currentDimensions)}
              onClick={() => setOpenDimensions(true)}
              InputProps={{
                readOnly: true,
              }}
            />
          </>
        )}
      </Box>
      <LocationPreview />
      {openDimensions && (
        <DimensionsModal
          field={{ label: "Dimensions" }}
          value={currentDimensions}
          onSubmit={handleDimensionsSave}
          nextRow={() => {}}
          onClose={() => setOpenDimensions(false)}
        />
      )}
    </Box>
  );
}
